import { API_NAMESPACE, USER_KEY } from "../theme/ConstantsProvider";

function getFromLocalStorage(namespace: string, key: string): any {
  let ls: { [key: string]: any } = {};
  if (global.localStorage) {
    try {
      // @ts-ignore
      ls = JSON.parse(global.localStorage.getItem(namespace)) || {};
    } catch (e) {}
  }
  return ls[key];
}

function saveToLocalStorage(namespace: string, key: string, value: any): any {
  if (global.localStorage) {
    global.localStorage.setItem(
      namespace,
      JSON.stringify({
        [key]: value,
      })
    );
  }
}

export function setUserKeyLocalStorage(key: string) {
  saveToLocalStorage(API_NAMESPACE, USER_KEY, key);
}

export function getUserKeyLocalStorage(): string {
  return getFromLocalStorage(API_NAMESPACE, USER_KEY);
}

export const jsonFetcher = (url: string) =>
  fetch(url).then((res) => res.json());

export const textFetcher = (url: string) =>
  fetch(url).then((res) => res.text());
